import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TenantContext = createContext({
  tenantSlug: '',
  tenantConfig: null,
  isTenantPortal: false,
  loading: true,
});

export function TenantProvider({ children, tenantSlug }) {
  const slug = tenantSlug || '';
  const [tenantConfig, setTenantConfig] = useState(null);
  const [loading, setLoading] = useState(!!slug);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/tenants/by-slug/${slug}/login-config`);
        if (!cancelled) setTenantConfig(res.data);
      } catch {
        if (!cancelled) setTenantConfig(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [slug]);

  return (
    <TenantContext.Provider value={{
      tenantSlug: slug,
      tenantConfig,
      isTenantPortal: !!slug,
      loading,
    }}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() {
  return useContext(TenantContext);
}
